
import { mapGetters, mapState } from 'vuex'
import { jsFn } from '@/utils/js-fn'
import CountryCode from '@/components/tool/countryCode/Index.vue'
import countrys from '@/assets/js/country_v2.json'
import profile from '@/utils/profile'

const CN_DIRECT_CITIES = ['11', '12', '31', '50']

export default {
    name: 'userRegistV2',
    head: {
        title: function() {
            return {
                inner: this.$t('pageTitle_2'),
                separator: ' '
            }
        }
    },
    components: {
        CountryCode
    },
    data() {
        const routeQuery = this.$route.query || {}
        const normalizeQueryValue = (value) => (value === undefined || value === null ? '' : value.toString().trim())

        const validAccount = (rule, value, callback) => {
            const errorMessage = this.getAccountValidationError(value)
            if (errorMessage) {
                callback(new Error(errorMessage))
            } else {
                callback()
            }
        }
        const validAccountCountryCode = (rule, value, callback) => {
            const errorMessage = this.getAccountCountryCodeValidationError(value)
            if (errorMessage) {
                callback(new Error(errorMessage))
            } else {
                callback()
            }
        }
        const validateName = (rule, value, callback) => {
            if (value.trim() === '') {
                callback(new Error(this.$t('error_1')))
            } else {
                callback()
            }
        }
        const validateRequired = (rule, value, callback) => {
            if (jsFn.isEmpty(value)) {
                callback(new Error(this.$t('error_1')))
            } else {
                callback()
            }
        }
        const validCellPheCheck = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('error_1')))
            } else if (!(/^[0-9]*$/.test(value))) {
                callback(new Error(this.$t('error_7')))
            } else {
                callback()
            }
        }
        const registValidatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('error_9')))
            } else if (!(/^(?=.*[a-zA-Z])(?=.*\d)[\S]{8,30}$/.test(value))) {
                callback(new Error(this.$t('error_5')))
            } else {
                if (this.form.passwdCheck !== '' && this.$refs.accountForm) {
                    this.$refs.accountForm.validateField('passwdCheck')
                }
                callback()
            }
        }
        const registValidatePassCheck = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('error_10')))
            } else if (value !== this.form.passwd) {
                callback(new Error(this.$t('error_11')))
            } else {
                callback()
            }
        }
        const validEmail = (rule, value, callback) => {
            if (!jsFn.isEmpty(value)) {
                const emailRule = /^[\w.+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)+$/
                if (value.search(emailRule) !== -1) {
                    callback()
                } else {
                    callback(new Error(this.$t('error_4')))
                }
            } else {
                callback()
            }
        }

        return {
            currentStep: 1,
            applyType: 'phone',
            isCN: false,
            agreePrivacy: false,
            countdown: false,
            sendLoading: false,
            verfTime: 0,
            areaPath: [],
            schoolOptionFlag: false,
            schoolOption: [],
            schooltFilterText: '',
            teammodelID:'',
            teammodelName: '',
            routeQuery: {
                clientId: normalizeQueryValue(routeQuery.client_id),
                oName: normalizeQueryValue(routeQuery.o_name),
                oMail: normalizeQueryValue(routeQuery.o_mail),
                openCode: normalizeQueryValue(routeQuery.open_code),
                appVer: normalizeQueryValue(routeQuery.app_ver),
                bind: normalizeQueryValue(routeQuery.bind),
                redirectUri: normalizeQueryValue(routeQuery.redirect_uri),
                entry: normalizeQueryValue(routeQuery.entry)
            },
            form: {
                account: '',
                accountCountryCode: '',
                validCode: '',
                name: '',
                passwd: '',
                passwdCheck: '',
                realName: '',
                mail: '',
                country: '',
                province: '',
                city: '',
                areaStr: '',
                unitName: '',
                schoolCode: '',
                unitType: '',
                jobTitle: ''
            },
            accountRuleValidate: {
                accountCountryCode: [
                    { validator: validAccountCountryCode, trigger: 'change' }
                ],
                account: [
                    { validator: validAccount, trigger: 'blur' }
                ],
                validCode: [
                    { validator: validCellPheCheck, trigger: 'blur' }
                ],
                name: [
                    { validator: validateName, trigger: 'blur' }
                ],
                passwd: [
                    { validator: registValidatePass, trigger: 'blur' }
                ],
                passwdCheck: [
                    { validator: registValidatePassCheck, trigger: 'blur' }
                ]
            },
            profileRuleValidate: {
                realName: [
                    { validator: validateName, trigger: 'blur' }
                ],
                mail: [
                    { validator: validEmail, trigger: 'blur' }
                ],
                areaStr: [
                    { validator: validateRequired, trigger: 'change' }
                ],
                unitName: [
                    { validator: validateRequired, trigger: 'blur' }
                ],
                unitType: [
                    { validator: validateRequired, trigger: 'change' }
                ],
                jobTitle: [
                    { validator: validateRequired, trigger: 'blur' }
                ]
            }
        }
    },
    computed: {
        ...mapState({
            verCountdownSec: state => state.verCountdownSec
        }),
        ...mapGetters({
            idToken: 'coreApi/getIdToken',
            pageLang: 'getLang',
            userExtend: 'coreApi/getUserExtend'
        }),
        currentSubtitle() {
            if (this.currentStep === 1) {
                return this.$t('userRegistV2.subtitle')
            }
            if (this.currentStep === 2) {
                 return this.$t('userRegistV2.subtitle2')
            }
            return this.$t('userRegistV2.completeSubtitle')
        },
        nextActionLabel() {
            switch (this.$i18n.locale) {
                case 'zh-tw':
                case 'zh-cn':
                    return 'Next step'
                case 'ja-jp':
                    return 'Next step'
                default:
                    return 'Next step'
            }
        },
        sendBtnText() {
            const text = this.applyType === 'email' ? this.$t('public_7') : this.$t('public_4')
            return this.countdown ? `${text}(${this.verfTime})` : text
        },
        isSendCodeDisabled() {
            return Boolean(
                this.countdown ||
                this.sendLoading ||
                this.getAccountValidationError(this.form.account) ||
                this.getAccountCountryCodeValidationError(this.form.accountCountryCode)
            )
        },
        completeLicenses() {
            return [
                {
                    name: this.$t('userRegistV2.completeLicenses.hiteach.name'),
                    duration: this.$t('userRegistV2.completeLicenses.hiteach.duration')
                },
                {
                    name: this.$t('userRegistV2.completeLicenses.aiPack.name'),
                    duration: this.$t('userRegistV2.completeLicenses.aiPack.duration')
                },
                {
                    name: this.$t('userRegistV2.completeLicenses.doubleAi.name'),
                    duration: this.$t('userRegistV2.completeLicenses.doubleAi.duration')
                }
            ]
        },
        accFormat() {
            let account = this.form.account
            if (this.applyType === 'phone' && this.form.accountCountryCode === 886 && account.indexOf('0') === 0) {
                account = account.substr(1)
            }
            return account
        },
        bindProvider() {
            const bind = (this.routeQuery.bind || '').toString().toLowerCase()
            return ['google', 'apple', 'wechat', 'educloudtw'].indexOf(bind) > -1 ? bind : ''
        },
        localeAreaCountry() {
            switch (this.$i18n.locale) {
                case 'ja-jp':
                    return 'JP'
                case 'ko-kr':
                    return 'KR'
                default:
                    return ''
            }
        },
        localeAreaCountryLabel() {
            const lang = this.$i18n.locale
            const country = countrys.find((item) => item.l === lang && item.t === 'c' && item.c === this.localeAreaCountry)
            return country ? country.cN : ''
        },
        filterSchoolOption() {
            if (this.schooltFilterText !== '') {
                const text = this.schooltFilterText.toLowerCase()
                const schoolRes = this.schoolOption.filter(function(item) {
                    return item.name.toLowerCase().indexOf(text) >= 0
                })

                if (schoolRes.length === 0) {
                    return [{ code: null, name: this.schooltFilterText, type: null }]
                }

                return schoolRes
            }

            return this.schoolOption
        },
        areaCascaderOptions() {
            const lang = this.$i18n.locale
            const countryNodes = countrys
                .filter((item) => item.l === lang && item.t === 'c')
                .map((item) => ({
                    value: item.c,
                    label: item.cN,
                    children: this.buildProvinceNodes(item.c, lang)
                }))

            if (lang === 'zh-tw') {
                countryNodes.sort((a, b) => {
                    if (a.label === '臺灣') return -1
                    if (b.label === '臺灣') return 1
                    return a.label.localeCompare(b.label)
                })
            }

            if (!this.localeAreaCountry) {
                return countryNodes
            }

            const targetCountry = countryNodes.find((item) => item.value === this.localeAreaCountry)
            return targetCountry ? targetCountry.children || [] : []
        },
        getLayerOneList() {
            const lang = this.$i18n.locale
            const res = []
            const fun = this.getLayerTwoList
            countrys.forEach(function(c) {
                if (c.l === lang && c.t === 'c') {
                    res.push({
                        value: c.c,
                        label: c.cN,
                        fun: fun
                    })
                }
            })

            if (lang === 'zh-tw') {
                res.sort(function(a, b) {
                    if (a.label === '臺灣') return -1
                    if (b.label === '臺灣') return 1
                    return a.label.localeCompare(b.label)
                })
            }

            return res
        },
        unitTypes() {
            return [
                { label: this.$t('extend_1'), value: '1' },
                { label: this.$t('extend_2'), value: '2' },
                { label: this.$t('extend_3'), value: '3' },
                { label: this.$t('extend_4'), value: '4' },
                { label: this.$t('extend_5'), value: '5' },
                { label: this.$t('extend_6'), value: '6' },
                { label: this.$t('extend_7'), value: '7' }
            ]
        }
    },
    watch: {
        applyType: function() {
            if (this.$refs.accountForm) {
                this.$refs.accountForm.fields.forEach(function(field) {
                    field.validateDisabled = true
                    field.validateState = ''
                    field.validateMessage = ''
                })
            }
        }
    },
    async mounted() {
        console.log(this.routeQuery)
        this.isCN = jsFn.isCN()
        if (this.isCN) {
            this.applyType = 'phone'
        }
        this.verfTime = this.verCountdownSec
        this.setDefaultCountryCode()
        this.applyBindPrefillFromQuery()

        if(this.routeQuery.redirectUri && this.routeQuery.openCode) {
            this.$Spin.show()
             let crtData = {
                grant_type : this.routeQuery.bind,
                client_id: this.routeQuery.clientId,
                open_code: this.routeQuery.openCode,
                app_version: this.routeQuery.appVer,
                lang: this.pageLang,
                redirect_uri: this.routeQuery.redirectUri
            }

            await this.$store.dispatch('coreApi/crtUser', crtData).then(res => {
                this.routeQuery.openCode = res.code
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                this.$Spin.hide() // 關閉加載畫面
            })
        }

        // 有ID token 代表有登入
        if(this.idToken) {
            let jwtData = jsFn.jwtDecode(this.idToken)
            this.teammodelID = jwtData.sub
            this.teammodelName = jwtData.name

            // 拿取票券兌換狀況
           const mynewsData = await this.$store.dispatch('coreApi/getUserSetting', 'mynews')
           const isMyNewsEnabled = ['DUALAI-2026', '333STEP1', 'GITHI3M'].every(code => mynewsData?.coupons?.some(x => x.code === code))

            if(isMyNewsEnabled) {
                this.currentStep = 3
            } else {
                this.currentStep = 2
                // 拿取個人進階資訊
                await this.$store.dispatch('coreApi/getUserExtend')
                if(this.userExtend) {
                    this.form.realName = this.userExtend.name ?? ''
                    this.form.mail = this.userExtend.mail ?? ''
                    this.form.jobTitle = this.userExtend.jobTitle ?? ''
                    this.form.unitType = this.userExtend.unitType ?? ''
                    this.form.city = this.userExtend.city ?? ''
                    this.form.country = this.userExtend.country ?? ''
                    this.form.province = this.userExtend.province ?? ''
                    this.syncAreaPathFromForm()
                    this.form.unitName = this.userExtend.unitName ?? ''
                    this.form.schoolCode = this.userExtend.schoolCode ?? ''
                }
            }
        }

        if (process.env.NODE_ENV !== 'development' && Object.keys(this.$route.query).length > 0) {
            this.$router.replace({
                path: this.$route.path,
                query: {}
            })
        }
    },
    methods: {
        downloadLink(type) {
            switch(type) {
                case 'applestore':
                    location.href = 'https://apps.apple.com/ca/app/hita-5/id1562290912'
                    break
                case 'googleplay':
                    location.href = 'https://play.google.com/store/apps/details?id=com.habook.hita5'
                    break
                case 'apk': {
                    let station = 'net'
                    if(this.isCN) {
                        station = 'cn'
                    }

                    location.href = `https://coreblob.teammodel.${station}/public/HiTA/APK/HiTA5.apk`
                    break
                }
            }
        },
        async loginHT() {
            // 如果網頁是www.mynews.teammodel.net/htfree/tw 轉到 www.account.teammodel.net/htfree
            // 要找Hiteach測試英文版和簡體版的時候會不會有問題
            // 要找米奇或我自己跳轉
            let url = profile.myNewsUrl['global']
            if(this.isCN) url = profile.myNewsUrl['cn']

            await this.$store.dispatch('coreApi/getCode', this.idToken, false).then(code => {
                location.href = `${url}/login/HT?code=${code}`
            }).catch((err) => {
                console.log(err)
            })
        },
        logOut() {
            sessionStorage.clear()

            if(this.routeQuery.entry === 'hiteach') {
                let url = profile.myNewsUrl['global']
                if(this.isCN) url = profile.myNewsUrl['cn']
                location.href = `${url}/logout/HT`
            } else {
                location.href = `/htfree`
            }
        },
        applyBindPrefillFromQuery() {
            if (!this.bindProvider) {
                return
            }

            const queryName = this.routeQuery.oName
            const queryMail = this.routeQuery.oMail

            if (!this.form.name && queryName) {
                this.form.name = queryName
            }

            if (!this.form.mail && queryMail) {
                this.form.mail = queryMail
            }
        },
        getAccountValidationError(value) {
            if (value === '') {
                return this.$t('error_1')
            }
            if (this.applyType === 'email') {
                return jsFn.isEmail(value) ? '' : this.$t('error_4')
            }
            if (!(/^[0-9]*$/.test(value))) {
                return this.$t('error_7')
            }
            return ''
        },
        getAccountCountryCodeValidationError(value) {
            if (this.applyType !== 'phone') {
                return ''
            }
            if (value === '') {
                return this.$t('error_6')
            }
            return ''
        },
        validateAccountField(fieldName) {
            return new Promise((resolve) => {
                if (!this.$refs.accountForm) {
                    resolve(false)
                    return
                }
                this.$refs.accountForm.validateField(fieldName, (message) => {
                    resolve(!message)
                })
            })
        },
        async sendVerf() {
            const fieldNames = this.applyType === 'phone'
                ? ['accountCountryCode', 'account']
                : ['account']
            const results = await Promise.all(fieldNames.map((fieldName) => this.validateAccountField(fieldName)))

            if (results.some((isValid) => !isValid)) {
                return
            }

            this.sendLoading = true
            const data = {
                country: this.form.accountCountryCode,
                account: this.applyType === 'phone' ? this.accFormat : this.form.account,
                lang: this.pageLang,
                HasUser: false
            }

            this.$store.dispatch('coreApi/sendOTPCodeV2', {
                type: this.applyType,
                data: data
            }).then(() => {
                this.$Message.info({
                    content: this.$t('public_8'),
                    duration: 5
                })
                this.startCountdown()
            }).catch((err) => {
                let text = this.$t('error_16')
                if (err.status) {
                    switch (err.status) {
                        case 429:
                            text = this.$t('error_38')
                            break
                    }
                } else {
                    switch (err.error) {
                        case 2:
                            text = this.applyType === 'phone' ? this.$t('error_12') : this.$t('error_8')
                            break
                    }
                }

                this.$Message.warning({
                    content: text,
                    duration: 7
                })
            }).finally(() => {
                this.sendLoading = false
            })
        },
        startCountdown() {
            this.countdown = true
            this.verfTime = this.verCountdownSec
            this.reciprocal()
        },
        reciprocal() {
            this.verfTime -= 1
            if (this.verfTime === 0) {
                this.countdown = false
                this.verfTime = this.verCountdownSec
            } else {
                setTimeout(() => this.reciprocal(), 1000)
            }
        },
        validateProfileAreaField(callback) {
            if (this.$refs.profileForm) {
                this.$refs.profileForm.validateField('areaStr', callback)
            }
        },
        setDefaultCountryCode() {
            let code = 1
            switch (this.pageLang) {
                case 'zh-tw':
                    code = 886
                    break
                case 'zh-cn':
                    code = 86
                    break
                case 'en-us':
                    code = 1
                    break
            }
            this.form.accountCountryCode = code
        },
        openAreaOption() {
            this.areaOptionFlag = true
            switch (this.$i18n.locale) {
                case 'ja-jp': {
                    const country = this.getLayerOneList.find(function(item) {
                        return item.value === 'JP'
                    })
                    this.getLayerTwoList('JP', country ? country.label : '')
                    break
                }
                case 'ko-kr': {
                    const country = this.getLayerOneList.find(function(item) {
                        return item.value === 'KR'
                    })
                    this.getLayerTwoList('KR', country ? country.label : '')
                    break
                }
                default:
                    this.areaOption = this.getLayerOneList
                    break
            }
        },
        getLayerTwoList(id, name) {
            const lang = this.$i18n.locale
            const fun = this.getLayerThrList
            this.form.country = id
            this.form.areaStr = name

            this.form.province = ''
            this.form.city = ''

            this.maskFlag = false
            const res = []
            if (this.form.country === 'TW') {
                countrys.forEach(function(c) {
                    if (c.l === lang && c.t === 'y' && c.c === id) {
                        res.push({
                            value: c.y,
                            label: c.yN,
                            fun: fun
                        })
                    }
                })
            } else {
                countrys.forEach(function(c) {
                    if (c.l === lang && c.t === 'p' && c.c === id) {
                        res.push({
                            value: c.p,
                            label: c.pN,
                            fun: fun
                        })
                    }
                })
            }

            if (res.length > 0) {
                this.areaOption = res
            } else {
                this.maskFlag = true
                this.areaOptionFlag = false
                this.$nextTick(() => {
                    this.validateProfileAreaField()
                })
            }
        },
        getLayerThrList(id, name) {
            this.form.province = id
            this.form.areaStr += `/${name}`

            const res = []
            const fun = this.setThrId
            const lang = this.$i18n.locale
            const country = this.form.country

            if (country === 'TW') {
                countrys.forEach(function(c) {
                    if (c.l === lang && c.t === 'd' && c.c === country && c.y === id) {
                        res.push({
                            value: c.d,
                            label: c.dN,
                            fun: fun
                        })
                    }
                })
            } else {
                const exception = ['11', '12', '31', '50']
                if (!(country === 'CN' && exception.indexOf(id) >= 0)) {
                    countrys.forEach(function(c) {
                        if (c.l === lang && c.t === 'y' && c.c === country && c.p === id) {
                            res.push({
                                value: c.y,
                                label: c.yN,
                                fun: fun
                            })
                        }
                    })
                }
            }

            if (res.length > 0) {
                this.areaOption = res
            } else {
                this.maskFlag = true
                this.areaOptionFlag = false
                this.$nextTick(() => {
                    this.validateProfileAreaField()
                })
            }
        },
        setThrId(thrId, thrName) {
            this.form.city = thrId
            this.form.areaStr += `/${thrName}`
            this.maskFlag = true
            this.areaOptionFlag = false
            this.$nextTick(() => {
                this.validateProfileAreaField()
            })
        },
        buildProvinceNodes(countryCode, lang) {
            const provinceType = countryCode === 'TW' ? 'y' : 'p'

            return countrys
                .filter((item) => item.l === lang && item.t === provinceType && item.c === countryCode)
                .map((item) => {
                    const provinceValue = countryCode === 'TW' ? item.y : item.p
                    const provinceLabel = countryCode === 'TW' ? item.yN : item.pN
                    const node = {
                        value: provinceValue,
                        label: provinceLabel
                    }

                    if (countryCode === 'CN' && CN_DIRECT_CITIES.indexOf(provinceValue) >= 0) {
                        return node
                    }

                    const cityType = countryCode === 'TW' ? 'd' : 'y'
                    const provinceKey = countryCode === 'TW' ? 'y' : 'p'
                    const cityValueKey = countryCode === 'TW' ? 'd' : 'y'
                    const cityLabelKey = countryCode === 'TW' ? 'dN' : 'yN'
                    const children = countrys
                        .filter((city) => city.l === lang && city.t === cityType && city.c === countryCode && city[provinceKey] === provinceValue)
                        .map((city) => ({
                            value: city[cityValueKey],
                            label: city[cityLabelKey]
                        }))

                    if (children.length > 0) {
                        node.children = children
                    }

                    return node
                })
        },
        syncAreaPathFromForm() {
            const { country, province, city } = this.form
            if (!country || !province) {
                return
            }

            const areaPath = this.localeAreaCountry
                ? [province]
                : [country, province]
            const selectedData = []
            let currentOptions = this.areaCascaderOptions

            for (const value of areaPath) {
                const matchedNode = (currentOptions || []).find((item) => item.value === value)
                if (!matchedNode) {
                    return
                }
                selectedData.push(matchedNode)
                currentOptions = matchedNode.children || []
            }

            if (city && currentOptions.length > 0) {
                const cityNode = currentOptions.find((item) => item.value === city)
                if (cityNode) {
                    areaPath.push(city)
                    selectedData.push(cityNode)
                }
            }

            this.handleAreaChange(areaPath, selectedData)
        },
        handleAreaChange(value, selectedData) {
            if (!value || value.length === 0) {
                this.areaPath = []
                this.form.country = null
                this.form.province = null
                this.form.city = null
                this.form.areaStr = ''
                this.form.unitName = ''
                this.form.schoolCode = null
                this.schoolOption = []
                this.schooltFilterText = ''
                this.$nextTick(() => {
                    this.validateProfileAreaField()
                })
                return
            }

            this.areaPath = value.slice()
            const labels = selectedData.map((item) => item.label)

            if (this.localeAreaCountry) {
                this.form.country = this.localeAreaCountry
                this.form.province = value[0] || null
                this.form.city = value[1] || null
                this.form.areaStr = [this.localeAreaCountryLabel].concat(labels).join('/')
            } else {
                this.form.country = value[0] || null
                this.form.province = value[1] || null
                this.form.city = value[2] || null
                this.form.areaStr = labels.join('/')
            }

            this.form.unitName = ''
            this.form.schoolCode = ''
            this.schoolOption = []
            this.schooltFilterText = ''

            this.$nextTick(() => {
                this.validateProfileAreaField()
            })
        },
        setSchool(name, type, code) {
            this.form.unitName = name
            this.form.schoolCode = code
            if (type) {
                this.form.unitType = type
            }
            this.schoolOptionFlag = false
        },
        openSchoolOption() {
            this.validateProfileAreaField(async(valid) => {
                if (!valid) {
                    this.$Spin.show()
                    this.schoolOptionFlag = true
                    this.schooltFilterText = ''
                    const data = {
                        country: this.form.country,
                        province: this.form.province,
                        city: this.form.city
                    }
                    await this.$store.dispatch('coreApi/getSchoolData', data).then((res) => {
                        this.schoolOption = res
                    }).catch((e) => {
                        console.log(e)
                    }).finally(() => {
                        this.$Spin.hide()
                    })
                }
            })
        },
        goToProfile() {
            this.$refs.accountForm.validate((valid) => {
                if (valid && this.agreePrivacy) {
                    this.$Spin.show() // 開啟加載畫面
                    let idFormat
                    if (this.applyType === 'phone') {
                        idFormat = '+' + this.form.accountCountryCode + '-' + this.accFormat
                    } else {
                        idFormat = this.accFormat.toLowerCase()
                    }

                    let crtData = {
                        account: idFormat,
                        name: this.form.name,
                        password: this.form.passwd,
                        pin_code: this.form.validCode,
                        lang: this.pageLang
                    }

                    if (this.routeQuery.openCode) {
                        crtData.grant_type = this.routeQuery.bind
                        crtData.open_code = this.routeQuery.openCode
                        crtData.client_id = this.routeQuery.clientId
                        crtData.app_version = this.routeQuery.appVer
                    }

                    if(this.routeQuery.redirectUri) crtData.redirect_uri = this.routeQuery.redirectUri

                    this.$store.dispatch('coreApi/crtUser', crtData).then(res => {
                        if(this.idToken) {
                            let jwtData = jsFn.jwtDecode(this.idToken)
                            this.teammodelID = jwtData.sub
                            this.teammodelName = jwtData.name
                        }
                        if (this.routeQuery.oName) this.form.realName = this.routeQuery.oName
                        this.currentStep = 2
                        window.scrollTo(0, 0)
                    }).catch(() => {
                        this.$Message.warning({
                            content: this.$t('error_14'),
                            duration: 5,
                            closable: true
                        })
                    }).finally(() => {
                        this.$Spin.hide() // 關閉加載畫面
                    })
                }
            })
        },
        goToComplete() {
            this.$refs.profileForm.validate(async(valid) => {
                if (valid) {
                    this.$Spin.show() // 開啟加載畫面
                    // 申請加入學校
                    await this.$store.dispatch('ies5Api/applySchool', this.form.schoolCode)

                    // 申請加入頻道
                    await this.$store.dispatch('sokplatformApi/applyChannel', this.form.schoolCode)

                    // 發送通知
                    this.pushNotify(this.teammodelID, this.teammodelName)

                    // 如果用Email註冊
                    if(this.applyType !== 'phone') this.sendMail({to: this.accFormat.toLowerCase(), tmid: this.teammodelID, name: this.teammodelName})

                    await this.$store.dispatch('coreApi/setContactAndGetCoupon', {
                        'name': this.form.realName,
                        'mail': this.form.mail,
                        'country': this.form.country,
                        'province': this.form.province,
                        'city': this.form.city,
                        'schoolCode': this.form.schoolCode,
                        'jobTitle': this.form.jobTitle,
                        'unitName': this.form.unitName,
                        'unitType': this.form.unitType
                    }).then(() => {
                        this.currentStep = 3
                        window.scrollTo(0, 0)
                    }).catch(e => {
                        this.$Message.warning({
                            content: this.$t('error_18'),
                            duration: 5,
                            closable: true
                        })
                    }).finally(() => {
                        this.$Spin.hide()
                    })
                }
            })
        },
        sendMail: async function({to, tmid, name}) {
            let tid = 'd-a104391a848744d4b45c6f8edf7aab2e'
            switch (this.pageLang) {
                case 'zh-tw':
                    tid = 'd-1871cc91dccf428989235e70aa031618'
                    break
                case 'zh-cn':
                    tid = 'd-7eed493d6faf457392bf9d5a5a13b860'
                    break
            }
            await this.$store.dispatch('coreApi/sendMail', {
                to: to,
                tid: tid,
                vars: {
                    name: name,
                    tmid: tmid
                }
            })
        },
        pushNotify: async function(tmId, name) {
            // 發送通知
            let btnUrl = 'https://www.habook.com/en/video.php?act=view&id=1'
            switch (this.pageLang) {
                case 'zh-tw':
                    btnUrl = 'https://www.habook.com/zh-tw/video.php?act=view&id=1'
                    break
                case 'zh-cn':
                    btnUrl = 'https://www.habook.com.cn/video.php?act=view&id=1'
                    break
            }
            await this.$store.dispatch('coreApi/pushNotify', {
                tags: [tmId],
                title: this.$t('userRegistV2.notify.title'),
                body: this.$t('userRegistV2.notify.body', {name: name, tmdId: tmId}),
                data: JSON.stringify({
                    action: [
                        {
                            type: 'click',
                            label: 'GO',
                            url: btnUrl,
                            tokenbindtype: 0
                        }
                    ]
                })
            })
        }
    }
}
